module.exports = __webpack_public_path__ + "8c9f2f13890cb4f490c72c3d67e2805e.svg";